import React from 'react';
import { useTranslation } from 'react-i18next';
import { getControlStyle, setImage } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';

export function Heading(props) {
  const { t } = useTranslation('common');
  const {
    headingType,
    otherConfiguration,
    fromForm,
    dataIndex,
    editingInput,
    deleteItem,
    placeholder,
    value,
    onChange,
    iconHeading,
    iconPath,
    keys,
    dppAddEditAccess,
    isProductArchived,
  } = props;
  const combinedStyles = getControlStyle(otherConfiguration);

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  return (
    <div className="heading-control">
      {/* default page start */}
      {!value && !iconPath && <div className="empty-heading">{t('DPP.CONTROL.HEADING.HEADING_TITLE')}</div>}
      {/* default page end */}

      {iconHeading && iconPath && (
        <div className="heading-icon">
          <figure>
            <img src={iconPath ? setImage(iconPath) : noImage} alt="" onError={handleImageError} />
          </figure>
        </div>
      )}
      {value && (
        <input
          type="text"
          placeholder={placeholder}
          className={`${headingType?.value === 'h1' ? 'fs-heading-h1' : 'fs-heading-h2'} form-control min-h-38`}
          value={value}
          autoComplete="off"
          onChange={(e) => onChange(e.target.value, dataIndex, keys)}
          style={combinedStyles}
          disabled={isProductArchived}
        />
      )}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default Heading;
